import { NotificationSchedulerModule } from './NotificationScheduler.types';

export default {
  addListener: () => {},
  removeListeners: () => {},
} as NotificationSchedulerModule;
